import { HTMLAttributes } from 'react';
import cn from 'classnames';

// Базовые типы для всех полей
export type BaseFieldAttributes = HTMLAttributes<
  HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
>;

export interface BaseFieldProps {
  name: string;
  label?: string;
  className?: string;
  wrapperClassName?: string;
  error?: string;
  placeholder?: string;
  showError?: boolean;
  labelClassName?: string;
  disabled?: boolean;
  readOnly?: boolean;
}

// Общие стили для всех полей
export const getFieldStyles = (
  error?: string,
  className?: string,
  disabled?: boolean,
  readOnly?: boolean,
) =>
  cn(
    'w-full h-12 text-black rounded-lg py-3 px-4 bg-white border border-solid border-grey-border focus:outline-none text-base leading-[120%] placeholder:text-grey-secondary placeholder:text-base placeholder:leading-[120%] transition-colors duration-300 ease-in-out',
    className,
    error && !readOnly && !disabled && 'border-[#FDA29B]',
    !error && !readOnly && !disabled && 'hover:border-[#3b3b3b]',
    !readOnly && !disabled && !error && 'focus:border-[#3b3b3b]',
    disabled && 'opacity-60 cursor-not-allowed bg-gray-50',
    readOnly && 'bg-gray-50 cursor-default',
  );

// Стили для полей с иконкой справа
export const getFieldWithIconStyles = (
  error?: string,
  className?: string,
  disabled?: boolean,
  readOnly?: boolean,
) => cn(getFieldStyles(error, className, disabled, readOnly), 'pr-[42px]');
